import PropTypes from "prop-types"

const JourneyAnswerShape = {
  answerCount: PropTypes.number,
  answerValue: PropTypes.string,
}

export default JourneyAnswerShape



// WEBPACK FOOTER //
// ./src/state/shapes/JourneyAnswerShape.js